import axios from "axios";
import { materialCloudServicesPath} from "../../../Constants";

const packingMaterialRestUrl = materialCloudServicesPath + '/user/units'

export default class MaterialCloudUnits {
    static async get() {
        return axios.get(`${packingMaterialRestUrl}`);
    }
}